import api from "services/api";
import apiMongo from "services/api-mongo";
import getContext from "helpers/getContext";
import { getAuthCookie } from "helpers/auth-cookie";
import { Creators as credentialsActions } from "../ducks/credentials";

export default (_store: any) => (next: any) => (action: any) => {
    let hasCookieAuth = false;

    if (action.type === "persist/REHYDRATE") {
        const cookieAuth = getAuthCookie();

        if (cookieAuth?.token) {
            hasCookieAuth = true;

            action.payload = {
                ...action.payload,
                auth: {
                    token: cookieAuth.token,
                    refresh_token: cookieAuth.refresh_token,
                    tokenLegacy: cookieAuth.tokenLegacy || ""
                }
            };

            api.defaults.headers.common.Authorization = `Bearer ${cookieAuth.token}`;
            apiMongo.defaults.headers.common.Authorization = `Bearer ${cookieAuth.token}`;
        }
    }

    const result = next(action);
    const state = _store.getState();

    if (action.type === "persist/REHYDRATE") {
        api.defaults.headers.common["X-Course"] = state.course.slug;
        api.defaults.headers.common["X-Context"] = getContext();

        if (hasCookieAuth && !state.credentials.id) {
            _store.dispatch(credentialsActions.getCredentialsRequest());
        }
    }

    return result;
};
